import 'css-chunksrc/client/scenes/calendarHolidaysCreation/styles.scss';export default {
  "calendarHolidaysCreation": "_calendarHolidaysCreation_2yk01_1",
  "main": "_main_2yk01_6",
  "footer": "_footer_2yk01_15",
  "button": "_button_2yk01_23"
};